// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"f26e5f98","467":"f26e5f98"}[chunkId] + ".chunk.css";
};